<template>
    <div class="quotation">
        <div class="header">
            <p class="header-title">实时行情</p>
            <a class="more" :href="moreUrl" target="_blank" v-if="!isUcenter"><span>更多</span><img :src="moreIcon" /></a>
            <a class="more" v-on:click="moreClick" v-else><span>更多</span><img :src="moreIcon" /></a>
        </div>
        <div class="currency-content">
            <div class="content-header">
                <li class="title">贵金属</li>
                <li class="price">买入价</li>
                <li>卖出价</li>
            </div>
            <div class="content-list">
                <div class="list-item" v-for="(item, index) in metals">
                    <li class="category">{{item.name}}</li>
                    <li class="price" :class="item.buyTrend == 0 ? '' : item.buyTrend == 1 ? 'up' : 'down'" v-on:click="buyCurrency(item, 0)">{{item.buyPrice}}</li>
                    <li :class="item.soldTrend == 0 ? '' : item.soldTrend == 1 ? 'up' : 'down'" v-on:click="soldCurrency(item, 1)">{{item.soldPrice}}</li>
                </div>
            </div>
            <div class="content-header m-top" >
                <li class="title">货币类型</li>
                <li class="price">买入价</li>
                <li>卖出价</li>
            </div>
            <div class="content-list">
                <div class="list-item" v-for="(item, index) in currencies">
                    <li class="category">{{item.name}}</li>
                    <li class="price" :class="item.buyTrend == 0 ? '' : item.buyTrend == 1 ? 'up' : 'down'" v-on:click="buyCurrency(item, 0)">{{item.buyPrice}}</li>
                    <li :class="item.soldTrend == 0 ? '' : item.soldTrend == 1 ? 'up' : 'down'" v-on:click="soldCurrency(item, 1)">{{item.soldPrice}}</li>
                </div>
            </div>
        </div>
        <pop-login v-if="showLoginDialog" v-on:popClose="popClose"></pop-login>
        <popup v-if="showTradeDialog" :is-default="isDefaultDialog">
            <trade-dialog :cmd="cmd" :trade-accounts="accounts" :title="tradeDialogTitle" @close-click="closeTradeDialog" :trade-info="orderCurrency" v-if="orderCurrency.name != '' && accounts.length > 0" :is-ucenter="isUcenter"></trade-dialog>
        </popup>
    </div>
</template>
<script>
    import moreIcon from '../../../static/img/ucenter/more.png'
    import currencySocket from 'currency.socket'
    import API from 'analystApi'
    import PopLogin from 'popLogin'
    import Popup from 'popup'
    import TradeDialog from 'ucenterTradeDialog'
    import messageCenter from 'message.center'
    export default {
        components: {
           PopLogin,
           Popup,
           TradeDialog
        },
        props:{
            // moreUrl:{
            //     type: String,
            //     default: ''
            // },
            isUcenter: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                moreIcon: moreIcon,
                metals:[],
                currencies:[],
                showLoginDialog: false,
                showTradeDialog: false,
                isDefaultDialog: false,
                cmd: '',
                accounts: [],
                tradeDialogTitle: '交易窗口',
                orderCurrency: {},
                currentAccount: {},
                moreUrl: window.PAGE_DATA.commonData.moreCurrencyUrl || ''

            }
        },
        mounted: function(){
            if (!this.isUcenter){
                this.getRealtimeCurrency();
            }else {
                this.getUcenterCurrency();
            }

        },
        created: function() {
            this.initDatas();

        },
        methods: {
            initDatas: function() {
                let self = this;
                let params = {
                    groupId: 0
                };
                API.getSymbolList(params).then((data)=>{
                    let res = data.data;
                    if (res.header.code == 1){
                        let arr = res.body;
                        if (arr.length > 0){
                            arr.forEach((item, index)=>{
                                item.buyPrice = '--';
                                item.soldPrice = '--';
                                item.buyTrend = 0;
                                item.soldTrend = 0;
                                if (item.name == '黄金'){
                                    self.metals.push(item);
                                }else if (item.name == '白银'){
                                    self.metals.push(item);
                                }else {
                                    self.currencies.push(item);
                                }

                            })
                        }

                        // self.initAccounts();
                    }
                }).catch((err)=>{

                })
            },
            initAccounts: function(item, index){

                let self = this;
                API.getAccountList().then((data)=>{
                    let res = data.data;

                    if (res.header.code == 1){
                        let content = res.body;

                        let arr = content.accountList;
                        let tempArr = [];
                        if (arr.length > 0){
                            arr.forEach((item, index)=>{
                                if (index == 0){
                                    item.selected = true;
                                }else {
                                    item.selected = false;
                                }
                                tempArr.push(item);
                            })
                            self.accounts = tempArr;
                            self.currentAccount = self.accounts[0];
                            self.showTradeDialog = true;
                            self.cmd = index;
                            self.orderCurrency = {};
                            self.orderCurrency = {
                                accountNo: this.currentAccount.accountNo,
                                accountType: this.currentAccount.accountType,
                                cmd: index == 0 ? '买入' : '卖出',
                                openPrice: index == 0 ? item.buyPrice : item.soldPrice,
                                symbol: item.code,
                                name: item.name
                            };
                        }else {
                            window.location.href = window.PAGE_DATA.commonData.openAccountUrl || '';
                        }
                    }

                }).catch((err)=>{

                });
            },
            getRealtimeCurrency: function(){
                let self = this;
                // let params = null;
                // let params = window.PAGE_DATA.commonData.userInfo.userId;
                currencySocket.getSocket().onmessage = function(res){
                    let data = res.data&&res.data;
                    if (typeof data === 'string') {
                        data = $.parseJSON(data);
                    }
                    self.setDatas(data);
                }

            },
            getUcenterCurrency: function(){
                let self = this;
                messageCenter.onMarketSocket((data)=>{
                    self.setDatas(data);
                })
            },
            setDatas: function(data){
                let self = this;
                let arr = data.symbol.split('.');
                let symbol = arr[arr.length-1];
                for(let i = 0;i < self.currencies.length;i++){
                    if(self.currencies[i].code == symbol){
                        if(parseFloat(data.ask) > parseFloat(self.currencies[i].buyPrice)){
                            self.currencies[i].buyTrend = 1;
                        }else if(parseFloat(data.ask) == parseFloat(self.currencies[i].buyPrice)){
                            self.currencies[i].buyTrend = 0;
                        }else{
                            self.currencies[i].buyTrend = 2;
                        }
                        if(parseFloat(data.bid) > parseFloat(self.currencies[i].soldPrice)){
                            self.currencies[i].soldTrend = 1;
                        }else if(parseFloat(data.bid) == parseFloat(self.currencies[i].soldPrice)){
                            self.currencies[i].soldTrend = 0;
                        }else{
                            self.currencies[i].soldTrend = 2;
                        }
                        self.currencies[i].buyPrice = data.ask;
                        self.currencies[i].soldPrice = data.bid;
                        messageCenter.notifyChangeBuyPrice(data.ask, symbol);
                        messageCenter.notifyChangeSoldPrice(data.bid, symbol);


                    }
                }
                for(let i = 0;i < self.metals.length;i++){
                    if(self.metals[i].code == symbol){
                        if(parseFloat(data.ask) > parseFloat(self.metals[i].buyPrice)){
                            self.metals[i].buyTrend = 1;
                        }else if(parseFloat(data.ask) == parseFloat(self.metals[i].buyPrice)){
                            self.metals[i].buyTrend = 0;
                        }else{
                            self.metals[i].buyTrend = 2;
                        }

                        if(parseFloat(data.bid) > parseFloat(self.metals[i].soldPrice)){
                            self.metals[i].soldTrend = 1;
                        }else if(parseFloat(data.bid) == parseFloat(self.metals[i].soldPrice)){
                            self.metals[i].soldTrend = 0;
                        }else{
                            self.metals[i].soldTrend = 2;
                        }
                        self.metals[i].buyPrice = data.ask;
                        self.metals[i].soldPrice = data.bid;
                        messageCenter.notifyChangeBuyPrice(data.ask, symbol);
                        messageCenter.notifyChangeSoldPrice(data.bid, symbol);
                    }
                }
            },
            // 货币买入
            buyCurrency: function(item, index){
                // console.log(this.accounts);
                let userId = window.PAGE_DATA.commonData.userInfo.userId;
                if (userId == null){
                    this.showLoginDialog = true;
                }else {
                    this.initAccounts(item, index);

                }

            },
            // 货币卖出
            soldCurrency: function(item, index){
                let userId = window.PAGE_DATA.commonData.userInfo.userId;
                if (userId == null){
                    this.showLoginDialog = true;
                }else {
                    this.initAccounts(item, index);
                }
            },
            // 关闭登录弹窗
            popClose: function(){
                this.showLoginDialog = false;
            },
            closeTradeDialog: function(){
                this.showTradeDialog = false;

            },
            moreClick: function(){
                this.$router.push({
                    path: '/',
                    query: {
                        more: 1
                    }
                })
            }
        }

    }
</script>
<style lang="scss" scoped>
    .quotation{
        width: 360px;
	    height: 630px;
	    background-color: #ffffff;
	    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        .header{
            width: 100%;
            height: 65px;
            padding: 24px 18px 24px 15px;
            position: relative;
            &:after{
                position: absolute;
                content: '';
                left: 0px;
                right: 0px;
                bottom: 0px;
                border-bottom: 1px solid #dadada;
            }
            .header-title{
                float: left;
                color: #364983;
                font-size: 16px;

            }
            .more{
                float: right;
                color: #666;
                font-size: 14px;
                cursor: pointer;
                span{
                    float: left;
                }
                img {
                    margin-top: 3px;
                    margin-left: 5px;
                    width: 14px;
                    height: 14px;
                    transform: rotate(-90deg);
                }
            }
        }
        .currency-content{
            padding: 30px 15px;
            .content-header{
                clear: both;
                &.m-top{
                    margin-top: 70px;
                }
                li {
                    float: left;
                    color: #374a84;
                    font-size: 16px;
                    width: 108px;
                    text-align: center;
                    &.title{
                        width: 70px;
                        text-align: left;
                    }
                    &.price{
                        margin-left: 38px;

                    }

                }
            }
            .content-list{
                clear: both;
                .list-item{
                    clear: both;
                    padding-top: 15px;
                    li {
                        float: left;
                        height: 34px;
                        width: 108px;
                        text-align: center;
                        line-height: 34px;
                        font-size: 14px;
                        color: #333;
                        &.category{
                            font-size: 14px;
                            color: #333;
                            width: 70px;
                            text-align: left;
                        }
                        &.price{
                            cursor: pointer;
                            margin-left: 38px;
                            border: solid 1px #dadada;
                            border-radius: 4px 0px 0px 4px;
                            border-right: none;
                            &.up{

                                color: #fff;
                                background-color: #ce2e2e;
                            }
                            &.down{

                                color: #fff;
                                background-color: #40b222;
                            }
                        }
                        &:last-child{
                            border: solid 1px #dadada;
                            border-radius: 0px 4px 4px 0px;

                        }
                        &.up{
                            border-up: none;
                            border-right: none;
                            border-bottom: none;
                            color: #fff;
                            background-color: #ce2e2e;
                        }
                        &.down{
                            border-up: none;
                            border-right: none;
                            border-bottom: none;
                            color: #fff;
                            background-color: #40b222;
                        }

                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/currency/quotation.vue